import React  , {  useState } from 'react';
import { DialogComponent, Spinner } from '../../../../Components';
import { RemoveAgentFromRotationSchemeAPI  } from '../../../../Services' ; 
import { showSuccess  , showError  } from '../../../../Helper' ; 
import { useTranslation } from 'react-i18next';


export const DeleteAgentFromRotationSchemeDialog = ({
  isOpen, 
  parentTranslationPath,
  translationPath,
  onSave,
  onClose , 
  activeItem, 
}) => {

  const { t } = useTranslation(parentTranslationPath);
  const [isLoading , setIsLoading ] = useState(false) ; 

  const deleteHandler = async () => {
    setIsLoading(true);
    const res = await RemoveAgentFromRotationSchemeAPI(activeItem && activeItem.convoloAgentId )
    if (!(res && res.status && res.status !== 200)) {
        showSuccess(t(`${translationPath}remove-agent-from-rotation-scheme-succes`));
        onSave();
    } else showError(t(`${translationPath}remove-agent-from-rotation-scheme-failed`));
    setIsLoading(false);
};

  return (
    <DialogComponent
        titleText='confirm-message'
        saveText={t(`${translationPath}confirm`)}
        SmothMove
        saveType='button'
        maxWidth='sm'
        dialogContent={(
          <div className='d-flex-column-center'>
            <Spinner isActive={isLoading} isAbsolute />
            <span className='mdi mdi-close-octagon c-danger mdi-48px' />
            <span className='fz-18px fw-bold'>
              {`${`${t(`${translationPath}are-you-sure-to-remove-agent-from-rotation-scheme`)}` || ''}`}
              <span className='d-flex-center  fz-22px fw-bold mt-2'>
                {' '}
                (
                {' '}
                {' '}
                {activeItem && activeItem.agentName}
                {' '}
                {' '}
                {' '}
                )
                {' '}
              </span>

            </span>
          </div>
        )}
        saveClasses='btns theme-solid bg-danger w-100 mx-2 mb-2'
        isOpen={isOpen}
        onSaveClicked={()=> deleteHandler()}
        onCloseClicked={() =>  onClose()}
        onCancelClicked={() => onClose() }
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
      />

  );
};
